import { createActionCreator } from 'deox';
import { EntityApps } from '@/types';

export const fetchRankEntitiesActions = {
  request: createActionCreator('FETCH_RANK_ENTITIES', (resolve) => (rankItemId: string) => resolve({ rankItemId })),
  success: createActionCreator('FETCH_RANK_ENTITIES_SUCCESS', (resolve) => (entities: EntityApps[]) =>
    resolve({ entities })
  ),
  failure: createActionCreator('FETCH_RANK_ENTITIES_FAILURE', (resolve) => (error: any) => resolve({ error })),
};
